import React, { useState } from "react";
import * as Yup from "yup";
import {
  Button,
  Select as AntdSelect,
  Table,
  Input,
  message as antdMessage,
  DatePicker,
} from "antd";
import {
  PlusCircleOutlined,
  SaveOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import {
  useForm,
  useFieldArray,
  FormProvider,
  Controller,
} from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import { useInsertCPFContributionRateMutation } from "AppQuries/master/CpfContributionRate/cpf-contribution-rate";
import { useResidentialsQuery } from "AppQuries/master/ResidentialType/get-all-residential-type";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import Select from "react-select";
import { ArrowLeft, PlusCircle, Save } from "react-feather";
import { claimDataValidation } from "core/Operations/ValidationSchema/claimValidationSchema";
import dayjs from "dayjs";
import { useInsertClaimMutation } from "AppQuries/claim/claim-management";
import { useGetClaimTypesQuery } from "AppQuries/claim/claim-type";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import { toast } from "core/Operations/toast";
import ImageUploader from "Components/UI/ImageUploder";
import { useFormattedEmployees } from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import MultiImageUploader from "Components/UI/MultiImageUploader";
import { use } from "react";

const activeStatusOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

const approvalStatusOptions = [
  { label: "Pending", value: 0 },
  { label: "Approved", value: 1 },
  { label: "Rejected", value: 2 },
];

const AddMultipleClaims = () => {
  const userData = useSelector(loggedInUser);
  const { data: claimTypes } = useGetClaimTypesQuery({
    companyCode: userData?.companyCode,
    isTrue: true,
  });

  const {
    mutate: addClaim,
    isError,
    error,
    isPending,
  } = useInsertClaimMutation();

  const claimTypeOptions = Array.isArray(claimTypes)
    ? claimTypes
        ?.filter((r) => r.isActive === true)
        .map((r) => ({ label: r.description, value: r.code.toString() }))
    : [];

  const employeeOption = useFormattedEmployees({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    departmentCode: 0,
  });

  const methods = useForm({
    defaultValues: {
      claimData: [],
    },
    resolver: yupResolver(claimDataValidation),
  });

  const navigate = useNavigate();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors, isSubmitting },
  } = methods;
  const { fields, append, remove } = useFieldArray({
    control,
    name: "claimData",
  });
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);

  const onSubmit = (payload) => {
    const claimData = payload?.claimData || [];
    console.log(claimData);
    addClaim(claimData, {
      onSuccess: (data) => {
        if (data?.[0]?.response === true) {
          toast.success("Claim Added Successfully.");
          setShowSuccessToast(true);
          // setTimeout(() => {
          navigate(`${all_routes.claim}${all_routes.claim_list}`);
          // }, 1000);
        } else {
          toast.error(data?.[0]?.errorMessage || "Something went wrong.");
          setShowErrorToast(true);
        }
      },
      onError: (error) => {
        console.log(error);
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const addRowHandler = () => {
    append({
      companyCode: userData.companyCode,
      code: 0,
      employeeCode: "",
      claimType: "",
      description: "",
      fromDate: "",
      toDate: "",
      transactionId: "",
      remarks: "",
      isApproval: 1,
      isActive: true,
      createUser: userData.userName,
      createDate: getCurrentFormattedDate(),
      modifyUser: userData.userName,
      modifyDate: getCurrentFormattedDate(),
      locationCode: userData.locationCode,
      claimAttachments: [],
    });
  };

  const addAttachments = (index, value) => {
    const currentAttachments =
      watch(`claimData[${index}].claimAttachments`) || [];

    const newAttachment = value?.map((val) => ({
      slNo: (currentAttachments.length || 0) + 1,
      companyCode: userData?.companyCode,
      code: 0,
      employeeCode: watch(`claimData[${index}].employeeCode`).toString() || 0,
      attachment: val,
      createUser: userData?.userName,
      createDate: getCurrentFormattedDate(),
      modifyUser: userData?.userName,
      modifyDate: getCurrentFormattedDate(),
      isActive: true,
    }));

    const updatedAttachments = [...currentAttachments, ...newAttachment];

    // const updatedClaimData = watch("claimData").map((item, idx) =>
    //   idx === index ? { ...item, attachment: updatedAttachments } : item
    // );
    console.log(updatedAttachments);
    setValue(`claimData[${index}].claimAttachments`, updatedAttachments);
  };

  const removeAttachment = (index, attachmentIndex) => {
    const currentAttachments =
      watch(`claimData[${index}].claimAttachments`) || [];
    const updatedAttachments = currentAttachments.filter(
      (item, idx) => idx !== attachmentIndex
    );
    setValue(`claimData[${index}].claimAttachments`, updatedAttachments);
  };
  const columns = [
    {
      title: "Actions",
      width: 100,
      render: (_, __, index) => (
        <Button
          icon={<DeleteOutlined />}
          type="text"
          onClick={() => remove(index)}
          danger
        />
      ),
    },
    {
      title: "Employee",
      dataIndex: "employeeCode",
      fixed: "left",
      width: 300,
      render: (_, __, index) => (
        <>
          <Controller
            name={`claimData[${index}].employeeCode`}
            control={control}
            defaultValue={watch(`claimData[${index}].employeeCode`)}
            render={({ field }) => (
              <Select
                {...field}
                options={employeeOption?.map((emp) => ({
                  label: emp.label,
                  value: emp.value,
                }))}
                placeholder="Select Employee"
                menuPortalTarget={document.body}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    fontSize: "12px",
                    width: "200px",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
                value={employeeOption.find(
                  (option) => option.value === field.value
                )}
                onChange={(e) => field.onChange(e.value)}
                className={`select ${
                  errors?.claimData?.[index]?.employeeCode ? "is-invalid" : ""
                }`}
              />
            )}
          />
          {errors?.claimData?.[index]?.employeeCode && (
            <div className="invalid-feedback">
              {errors.claimData?.[index]?.employeeCode.message}
            </div>
          )}
        </>
      ),
    },
    {
      title: "Claim Type",
      dataIndex: "claimType",
      width: "40%",
      render: (_, __, index) => (
        <>
          <Controller
            name={`claimData[${index}].claimType`}
            control={control}
            defaultValue={watch(`claimData[${index}].claimType`)}
            render={({ field }) => (
              <Select
                {...field}
                options={claimTypeOptions}
                menuPortalTarget={document.body}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    fontSize: "12px",
                    width: "200px",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
                value={claimTypeOptions.find(
                  (option) => option.value === field.value
                )}
                onChange={(e) => field.onChange(e.value)}
                className={
                  errors?.claimData?.[index]?.claimType ? "is-invalid" : ""
                }
              />
            )}
          />
          {errors?.claimData?.[index]?.claimType && (
            <div className="invalid-feedback">
              {errors.claimData?.[index]?.claimType.message}
            </div>
          )}
        </>
      ),
    },
    {
      title: "Transaction Id",
      dataIndex: "transactionId",
      width: "40%",
      render: (_, __, index) => (
        <Controller
          name={`claimData[${index}].transactionId`}
          control={control}
          render={({ field }) => (
            <input
              {...field}
              placeholder="Transaction Id"
              className={`form-control ${
                errors?.claimData?.[index]?.transactionId ? "is-invalid" : ""
              }`}
              style={{ width: "200px" }}
            />
          )}
        />
      ),
    },

    {
      title: "Description",
      dataIndex: "description",
      width: 200,
      render: (_, __, index) => (
        <Controller
          name={`claimData[${index}].description`}
          control={control}
          render={({ field }) => (
            <input
              {...field}
              placeholder="Description"
              className={`form-control ${
                errors?.claimData?.[index]?.description ? "is-invalid" : ""
              }`}
              style={{ width: "200px" }}
            />
          )}
        />
      ),
    },

    {
      title: "Amount",
      dataIndex: "claimAmount",
      width: 200,
      render: (_, __, index) => (
        <Controller
          name={`claimData[${index}].claimAmount`}
          control={control}
          render={({ field }) => (
            <input
              {...field}
              placeholder="Claim Amount"
              className={`form-control ${
                errors?.claimData?.[index]?.claimAmount ? "is-invalid" : ""
              }`}
              style={{ width: "200px" }}
            />
          )}
        />
      ),
    },

    {
      title: "From Date",
      dataIndex: "fromDate",
      width: 150,
      render: (_, __, index) => (
        <>
          <Controller
            name={`claimData[${index}].fromDate`}
            control={control}
            render={({ field }) => (
              <DatePicker
                {...field}
                placeholder="Select from date"
                value={field.value ? dayjs(field.value, "YYYY-MM-DD") : null}
                format={"DD-MM-YYYY"}
                className={`form-control ${
                  errors?.claimData?.[index]?.fromDate ? "is-invalid" : ""
                }`}
                onChange={(date) =>
                  date ? field.onChange(dayjs(date).format("YYYY-MM-DD")) : null
                }
                style={{
                  width: "150px",
                }}
              />
            )}
          />
          {/* {errors?.claimData?.[index]?.fromDate && (
            <div className="invalid-feedback">
              {errors.claimData?.[index]?.fromDate.message}
            </div>
          )} */}
        </>
      ),
    },

    {
      title: "To Date",
      dataIndex: "toDate",
      width: "40%",
      render: (_, __, index) => (
        <>
          <Controller
            name={`claimData[${index}].toDate`}
            control={control}
            render={({ field }) => (
              <DatePicker
                {...field}
                placeholder="Select to date"
                value={field.value ? dayjs(field.value, "YYYY-MM-DD") : null}
                format={"DD-MM-YYYY"}
                className={`form-control ${
                  errors?.claimData?.[index]?.toDate ? "is-invalid" : ""
                }`}
                onChange={(date) =>
                  date ? field.onChange(dayjs(date).format("YYYY-MM-DD")) : null
                }
                style={{
                  width: "150px",
                }}
              />
            )}
          />
          {errors?.claimData?.[index]?.toDate && (
            <div className="invalid-feedback">
              {errors.claimData?.[index]?.toDate.message}
            </div>
          )}
        </>
      ),
    },

    {
      title: "Remarks",
      dataIndex: "remarks",
      width: 200,
      render: (_, __, index) => (
        <Controller
          name={`claimData[${index}].remarks`}
          control={control}
          render={({ field }) => (
            <input
              {...field}
              placeholder="Remarks"
              className={`form-control ${
                errors?.claimData?.[index]?.remarks ? "is-invalid" : ""
              }`}
              style={{ width: "200px" }}
            />
          )}
        />
      ),
    },

    {
      title: "Attachment",
      dataIndex: "claimAttachments",

      render: (_, __, index) => (
        <div style={{ width: "300px" }}>
          {watch(`claimData[${index}].employeeCode`) ? (
            <MultiImageUploader
              key={index}
              base64Value={watch(`claimData[${index}].claimAttachments`)?.map(
                (a) => a.attachment
              )}
              setBase64Values={(value) => {
                addAttachments(index, value);
              }}
              removeAttachment={(attachmentIndex) =>
                removeAttachment(index, attachmentIndex)
              }
              id={`claim-attachment-uploader-${index}`}
            />
          ) : (
            <em>Please select employee first</em>
          )}
        </div>
      ),
    },
    {
      title: "Approval",
      dataIndex: "isApproval",
      width: 100,
      render: (_, __, index) => (
        <Controller
          name={`claimData[${index}].isApproval`}
          control={control}
          defaultValue={watch(`claimData[${index}].isApproval`)}
          render={({ field }) => (
            <Select
              {...field}
              options={approvalStatusOptions}
              menuPortalTarget={document.body}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  fontSize: "12px",
                  width: "100px",
                }),
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
              value={approvalStatusOptions.find(
                (option) => option.value === field.value
              )}
              onChange={(e) => field.onChange(e.value)}
              className={
                errors?.claimData?.[index]?.isApproval ? "is-invalid" : ""
              }
            />
          )}
        />
      ),
    },

    {
      title: "Status",
      dataIndex: "isActive",
      width: 100,
      render: (_, __, index) => (
        <Controller
          name={`claimData[${index}].isActive`}
          control={control}
          defaultValue={watch(`claimData[${index}].isActive`)}
          render={({ field }) => (
            <Select
              {...field}
              options={activeStatusOptions}
              menuPortalTarget={document.body}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  fontSize: "12px",
                  width: "100px",
                }),
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
              value={activeStatusOptions.find(
                (option) => option.value === field.value
              )}
              onChange={(e) => field.onChange(e.value)}
              className={
                errors?.claimData?.[index]?.isActive ? "is-invalid" : ""
              }
            />
          )}
        />
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="content">
            <div className="page-header">
              <div className="add-item d-flex">
                <div className="page-title">
                  <h4>Add Claims Request</h4>
                  <h6>List out employees claims</h6>
                </div>
              </div>
              <div className="page-btn">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="back">Back</Tooltip>}
                >
                  <Link
                    to={`${all_routes.claim}${all_routes.claim_list}`}
                    className="btn btn-secondary"
                  >
                    {/* <ArrowLeft className="me-2" /> */}
                    Back
                  </Link>
                </OverlayTrigger>
              </div>
              <div className="page-btn">
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Save Claim Data</Tooltip>
                  }
                >
                  <button
                    type="submit"
                    className="btn btn-added"
                    disabled={isPending || isSubmitting}
                  >
                    &nbsp;
                    {isPending || isSubmitting ? (
                      <>
                        <i className="fas fa-spinner fa-spin me-2"></i>
                        Loading...
                      </>
                    ) : (
                      <>
                        <Save className="me-2" />
                        Save
                      </>
                    )}
                  </button>
                </OverlayTrigger>
              </div>
            </div>
            <div className="card border-0">
              <div className="card-header d-flex justify-content-between">
                <h4 className="card-title">Claim Data</h4>
                <button
                  type="button"
                  className="btn btn-success rounded-pill btn-sm"
                  onClick={addRowHandler}
                >
                  <PlusCircle className="me-2" />
                  Add Row
                </button>
              </div>

              <div className="table-list-card">
                <div className="">
                  <div className="table-responsive">
                    <Table
                      columns={columns}
                      dataSource={fields}
                      pagination={false}
                      rowKey="id"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default AddMultipleClaims;
